// ... existing code ...
import request from '@/utils/request'

export function login(data) {
  return request.post('/auth/login', data)
}

export function logout() {
  return request.post('/user/logout')
}

export function getUserInfo() {
  return request('/user/me')
}

export function getEmailCode() {
  return request.get('/user/email-code')
}

export function resetPassword() {
  return request.post('/user/reset-password')
}

export function register() {
  return request.post('/user/register')
}
// 修改用户头像
export function updateUserAvatarApi(data) {
  return request.post('/v1/updateAvatar', data)
}

// 修改昵称
export function updateNicknameApi(data) {
  return request.post('/v1/updateNickname', data)
}

// 修改密码
export function changePasswordApi(data) {
  return request.post('/v1/changePassword', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// 判断账户存在
export function checkUserApi(data) {
  return request.post('/user/checkUser', data)
}

// 图片公告弹窗信息
export function activityPopupImg() {
  return request.get('/activity/popupImg')
}
// 图片弹窗图登录后
export function activityFloatingImgLogin() {
  return request.get('/activity/floatingImgLogin')
}

// 站内信息列表
export function siteMessageList(data) {
  return request.post('/v1/siteMessage/list', data)
}

// 查未读的站内信息
export function siteMessageUnread() {
  return request.get('/v1/siteMessage/unread')
}

// 设置站内信页列表已读
export function siteMessageRead(data) {
  return request.post('/v1/siteMessage/read', data)
}

// 设置弹窗站内信已读
export function siteMessageReadByMessageId(data) {
  return request.post('/v1/siteMessage/readByMessageId', data)
}
